import { useEffect, useState } from "react";
import { KioskTimeOption } from "./kioskTimeOption";
import Enums from "../../utilities/enum";
import { DndContext, closestCorners, PointerSensor, useSensors, useSensor } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";
import stringHelpers from "../../utilities/stringHelpers";

export const KioskTimeConfig = (props) => {
	const [inputValue, setInputValue] = useState(0);
	const [customLabel, setCustomLabel] = useState("");
	const [startTimeDeltaMinutes, setStartTimeDeltaMinutes] = useState(null)
	const [endOfDayDeltaMinutes, setEndOfDayDeltaMinutes] = useState(-1)
	const [maximumTimeOfDay, setMaximumTimeOfDay] = useState("");
	const [mode, setMode] = useState(0);
	const [editModalContent, setEditModalContent] = useState(null);
	const [sortingArray, setSortingArray] = useState(null);

	const sensors = useSensors(
		useSensor(PointerSensor, {
		  activationConstraint: {
			distance: 5,
		  },
	}))

	useEffect(() => {
		setSortingArray(props.data.map((item, index) => ({
			id: String(index),
			...item
		})));
	}, [props.data])

	const updateModal = (id, dataPoint) => {

		setEditModalContent({
			id: Number(id),
		});
		setMode(dataPoint.type);
		setInputValue(dataPoint.duration);
		setCustomLabel(!stringHelpers.isNullOrEmpty(dataPoint.label) ? dataPoint.label : "")
		setStartTimeDeltaMinutes(dataPoint.startTimeDeltaMinutes)
		setEndOfDayDeltaMinutes(dataPoint.endOfDayDeltaMinutes)
		setMaximumTimeOfDay(dataPoint.maximumTimeOfDay)
	};

	const getElementPosition = (id) => sortingArray.findIndex((item) => item.id === id);

	const handleDragEndTable = (event) => {
		if (props.editMode) {
			const { active, over } = event;
			if (active.id === over.id) return;
			const originalPosition = getElementPosition(active.id);
			const newPosition = getElementPosition(over.id);
			props.updateList(() => {
				const reOrderedArray = arrayMove(sortingArray, originalPosition, newPosition);
				return reOrderedArray.map(item => {
					const {id, ...rest} = item;
					return rest;
				})
			});
		}
	};

	const resetValues = () => {
		setEditModalContent(null);
		setInputValue("0");
		setMode("0");
		setCustomLabel("")
		setStartTimeDeltaMinutes(null)
		setEndOfDayDeltaMinutes(-1)
		setMaximumTimeOfDay("")
	}
 
	const customLabelPlaceholder = () => {
		return stringHelpers.isNullOrEmpty(customLabel) 
		? `${inputValue !== null ? `${inputValue} ` : ""}${!inputValue || inputValue > 1 ? Enums.TimeSpanMode[String(mode)] : Enums.TimeSpanMode[String(mode)].substring(0, Enums.TimeSpanMode[String(mode)].length - 1)}`
		: customLabel
	}

	return (
		<div className="d-flex flex-column mb-3">

			{/* Add Upate Time Span Modal */}
			<div
				className="modal fade"
				id="add-time-span-modal"
				role="dialog"
				aria-labelledby="Add Time Span Option Modal"
				aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="addTimeSpanOptionLabel">
								{editModalContent ? <>Update</> : <>Add a</>} Time Span Option.
							</h5>
							<button
								type="button"
								className="close"
								data-dismiss="modal"
								aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="row">
								<div className="col-12">
									<div className="form-group mb-0">
										<div className="d-flex flex-column mb-3">
											<p className="m-0">Time Span Mode</p>
											<small className="mb-2">Select the type of allow list validity for this option.</small>
											<select
												onChange={(e) => {
													setMode(Number(e.target.value))
													setEndOfDayDeltaMinutes(-1)
													if (e.target.value === "3" || e.target.value === "4") setInputValue(null);
												}}
												id="mode-select"
												className="border py-1 rounded px-2">
												{Object.entries(Enums.TimeSpanMode).map(
													([k, v]) => <option selected={k === String(mode)} value={k} key={k}>{v}</option>
												)}
											</select>
										</div>
										{
											mode !== 3 && mode !== 4 && (
												<div className="d-flex flex-column mb-3">
													<p className="m-0" htmlFor="time-value-input">Provide a value</p>
													<small className="mb-2">Specify how many {Enums.TimeSpanMode[String(mode)].toLowerCase()} for allow list validity.</small>
													<input
														min={0}
														className="border py-1 rounded px-2"
														onChange={(e) => setInputValue(Number(e.target.value))}
														id="time-value-input"
														type="number"
														value={inputValue}
													/>
												</div>
											)
										}

										<div className="d-flex flex-column mb-3">
											<p className="m-0" htmlFor="label-input">Label</p>
											<small className="mb-2">Optional: you can override the default label for this option on the app by providing a value here.</small>
											<input
												onChange={(e) => setCustomLabel(e.target.value)}
												id="label-input"
												type="text"
												className="border py-1 rounded px-2"
												value={customLabel}
												placeholder={customLabelPlaceholder()}
											/>
										</div>

										<div className="d-flex flex-column mb-3">
											<p className="m-0" htmlFor="start-delta-value-input">Start Time Delta (mins)</p>
											<small className="mb-2">Optional: specify a positive or negative value to add to the allow list validity start time.</small>
											<input
												className="border py-1 px-2 rounded"
												onChange={(e) => setStartTimeDeltaMinutes(Number(e.target.value))}
												id="start-delta-value-input"
												type="number"
												value={startTimeDeltaMinutes}
											/>
										</div>

										{mode === 3 && <div className="d-flex flex-column mb-3">
											<p className="m-0" htmlFor="end-delta-value-input">End of Day Delta (mins)</p>
											<small className="mb-2">Optional: specify a positive or negative value to add to the end time, e.g -30 to end the allow list validity at 23:30.</small>
											<input
												className="border py-1 px-2 rounded"
												onChange={(e) => setEndOfDayDeltaMinutes(Number(e.target.value))}
												id="end-delta-value-input"
												type="number"
												value={endOfDayDeltaMinutes}
											/>
										</div>}

										<div className="d-flex flex-column mb-3">
											<p className="m-0" htmlFor="end-delta-value-input">Maximum Time of Day</p>
											<small className="mb-2">Optional: limit the end time of the allow list validity, e.g if a car park closes at a specific time.</small>
											<div className="input-group input-group-sm">
                                                <input className="form-control px-2 py-3" type="time" value={maximumTimeOfDay} onChange={(e) => setMaximumTimeOfDay(e.target.value)} />
												<button onClick={() => setMaximumTimeOfDay("")} className='btn p-0'><i className='fa fa-times mx-2'></i></button>
                                            </div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button
								onClick={() => resetValues()}
								type="button"
								className="btn btn-falcon-default btn-sm ml-2"
								data-dismiss="modal">
								Cancel
							</button>
							<button
								type="button"
								className="btn btn-success btn-sm ml-2"
								data-dismiss="modal"
								onClick={() => {
									if (editModalContent) {
										props.handleUpdateRow(editModalContent.id, inputValue, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, stringHelpers.isNullOrEmpty(maximumTimeOfDay) ? null : maximumTimeOfDay);
									} else {
										props.handleAddRow(inputValue, mode, customLabel, startTimeDeltaMinutes, endOfDayDeltaMinutes, stringHelpers.isNullOrEmpty(maximumTimeOfDay) ? null : maximumTimeOfDay);
									}
									resetValues()
								}}>
								Confirm
							</button>
						</div>
					</div>
				</div>
			</div>
			
			{/* Delete Time span modal */}
			{editModalContent && (
				<div
					className="modal fade"
					id="delete-time-span-modal"
					role="dialog"
					aria-labelledby="Delete Time Span Option Modal"
					aria-hidden="true">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="deleteTimeSpanOptionLabel">
									Are you sure you want to delete this time option?
								</h5>
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-footer">
								<button
									onClick={() => resetValues()}
									type="button"
									className="btn btn-falcon-default btn-sm ml-2"
									data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									className="btn btn-danger btn-sm ml-2"
									data-dismiss="modal"
									onClick={() => {
										props.handleDeleteRow(editModalContent.id);
										resetValues()
									}}>
									Confirm
								</button>
							</div>
						</div>
					</div>
				</div>
			)}

			{
				sortingArray && (
					<DndContext sensors={sensors} onDragEnd={handleDragEndTable} collisionDetection={closestCorners}>
						<table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
							<SortableContext items={sortingArray}
											strategy={verticalListSortingStrategy}>
								<tbody>
									{sortingArray.map((dataPoint, index) => {
											return (
												<KioskTimeOption
													id={dataPoint.id}
													editMode={props.editMode}
													key={index}
													handleUpdateModal={(id) => updateModal(id, dataPoint)}
													option={dataPoint}
												/>
											);
									})}
								</tbody>
							</SortableContext>
						</table>
					</DndContext>
				)
			}
			{props.editMode && (
				<button
					onClick={() => resetValues()}
					className="btn btn-success btn-sm align-self-start mt-2"
					data-toggle="modal"
					data-target="#add-time-span-modal">
				<i className="fas fa-plus mr-1"></i>Add
			</button>
			)}
		</div>
	);
};